import { config } from '../config';

/**
 * 全局调试输出，配置config.log.isPrint
 * @param {*} cont 输出内容
 * @param {*} title 位置描述
 */
const print = (cont, title) => {
  if (config.log.isPrint) {
    if (title) {
      console.log(cont, title);
    } else {
      console.log(cont);
    }
  }
};

export { print };
